export default "__VITE_ASSET__kMPgfkDA__"